<template>
  <div>
    <div class="img_show">
      <el-carousel :interval="4000" type="card" height="350px">
        <el-carousel-item v-for="(item,index) in fileList" :key="index">
          <img :src="item.url" class="image">
        </el-carousel-item>
      </el-carousel>
      <div class="comment_show">
        <ul>
          <li v-for="(item,index) in commentList" :key="index">
            <span style="color: red" class="comment_head">{{item.username}}</span>
            <span style="color: orange" class="comment_head">{{dateFormat('YYYY-mm-dd HH:MM:SS',item.date)}}</span>
            <i class="el-icon-delete" v-if="item.userid === userId" @click="deleteComment(item.id,index)"></i>
            <span style="color: orchid" class="comment_main">{{item.content}}</span>
          </li>
        </ul>
      </div>
      <el-row :gutter="20" style="margin-top: 170px">
        <el-col :span="18">
          <el-input
              type="textarea"
              placeholder="请发表你的看法"
              v-model="textarea"
              maxlength="30"
              show-word-limit
          >
          </el-input>
        </el-col>
        <el-col :span="6">
          <div class="comment_button">
            <el-button type="warning" @click="addComment">发表</el-button>
          </div>
        </el-col>
      </el-row>

    </div>
    <div class="info_show">
      <h3 class="car_fullname_class">
        {{car.fullname}}
      </h3>
      <div class="car_tags">
        {{car.ownernum}}
      </div>
      <div class="car_box">
        <li class="basic_li">
          <span class="item_name">品牌</span>
          {{car.brandinfo}}
        </li>
        <li class="basic_li">
          <span class="item_name">
            颜色
          </span>
          {{car.color}}
        </li>
        <li class="basic_li">
          <span class="item_name" style="width: auto;padding-right: 30px">
            变速箱/排量
          </span>
          {{car.gearbox}}/{{car.displacement}}T
        </li>
        <li class="basic_li">
          <span class="item_name">
            表显里程
          </span>
          {{car.distance/10000}}万公里
        </li>
        <li class="basic_li">
          <span class="item_name">
            购车时间
          </span>
          {{car.paydate}}
        </li>
        <li class="basic_li">
          <span class="item_name">
            卖家
          </span>
          {{car.username}}
        </li>
      </div>
      <div class="price_show">
        <span class="price">
          ￥{{car.price}}
          <b>万</b>
        </span>
        <el-tag type="info" style="margin-top: 20px">不含过户费</el-tag>
      </div>
      <div class="collect_class">
        <el-button :type="collectType" :icon="collectIcon" @click="collect">{{collectInfo}}</el-button>
      </div>
      <div class="car_buy" v-if="car.state === 0 && car.userid !== userId">
        <el-button type="primary" class="buttonClass" round @click="payForCar">立即预订</el-button>
      </div>
    </div>


  </div>

</template>

<script>
export default {
  name: "CarInfo",
  data(){
    return{
      userId:this.$store.state.UserInfo.user ? this.$store.state.UserInfo.user.user.id : '',
      car: {},
      fileList: [],
      // 浏览器宽度
      screenWidth :0,
      collectIcon:'el-icon-star-off',
      collectInfo: '收藏',
      collectType: 'info',
      textarea: '',
      commentList: []

    }
  },
  methods:{

    //购买
    payForCar(){
      this.axios.post('/api/ali-pay/trade/page/pay/' + this.car.id + '/' + this.userId + '').then(res => {
        // console.log(res.data)
        document.write(res.data.data.formStr)
      })
    },

    //删除评论
    deleteComment(commentId,index){
      this.axios.get('/car/deleteComment/' + commentId + '').then(res => {
        if(res.data.code === 0){
          this.commentList.splice(index,1)
        }
      })
    },

    //时间转化
    dateFormat(fmt, date) {
      let ret="";
      date=new Date(date);
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      }
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(
              ret[1],
              ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
          )
        }
      }
      return fmt
    },

    addComment(){
      if(!this.textarea){
        this.$message.error('请输入评论信息')
      }else{
        var fd = new FormData();
        let obj = {
          carId: this.car.id,
          userId: this.userId,
          content: this.textarea
        }
        fd.append('info',JSON.stringify(obj))
        this.axios.post('/car/comment',fd).then(res => {
          if(res.data.code === 0){
            this.$message.success('发表成功');

            //更新评论信息
            this.axios.get('/car/getAllComment/' + obj.carId + '').then(res => {
              if(res.data.code === 0){
                this.commentList = res.data.data.cList
              }
            })
            this.textarea = ''
          }
        })
      }

    },

    //下面是自适应框体大小的设置
    setSize:function () {
      // 通过浏览器宽度(图片宽度)实现计算高度
      this.bannerHeight = 400 / 1920 * this.screenWidth;
    },

    //收藏
    collect(){

      let obj = {
        carId: this.car.id,
        userId: this.$store.state.UserInfo.user.user.id,
        TYPE: ''
      }
      var fd = new FormData()
      if(this.collectIcon === 'el-icon-star-on'){
        //取消收藏
        obj.TYPE = 'CANCEL'
        fd.append('collectInfo',JSON.stringify(obj))
        this.axios.post('/car/optionCollect',fd).then(res => {
          if(res.data.code === 0){
            this.$message.success('取消收藏')
            this.collectIcon = 'el-icon-star-off'
            this.collectInfo = '收藏'
            this.collectType = 'info'
          }else {
            this.$message.error('系统错误')
            this.$router.replace('/index/buy')
          }
        })
      }else {
        //收藏
        obj.TYPE = 'COLLECT'
        fd.append('collectInfo',JSON.stringify(obj))
        this.axios.post('/car/optionCollect',fd).then(res =>{
          if(res.data.code === 0){
            this.$message.success('收藏成功')
            this.collectIcon = 'el-icon-star-on'
            this.collectInfo = '已收藏'
            this.collectType = 'warning'
          }else {
            this.$message.error('系统错误')
            this.$router.replace('/index/buy')
          }
        })
      }
    }

  },
  created() {
    var carId = this.$route.query.carId
    var userId = this.$store.state.UserInfo.user.user.id

    //评论信息
    this.axios.get('/car/getAllComment/' + carId + '').then(res => {
      if(res.data.code === 0){
        this.commentList = res.data.data.cList
      }
    })

    //收藏信息
    this.axios.get('/car/getCollectInfo/' + userId + '/' + carId + '').then(res => {
      if(res.data.code === 0){
          if(res.data.data.isCollect){
            this.collectIcon = 'el-icon-star-on'
            this.collectInfo = '已收藏'
            this.collectType = 'warning'
          }else {
            this.collectIcon = 'el-icon-star-off'
            this.collectInfo = '收藏'
            this.collectType = 'info'
          }
      }else {
        this.$message.error('信息获取错误')
        this.$router.replace('/index/buy')
      }
    })

    //车辆信息
    this.axios.get('/car/getCarAllInfoById/' +carId + '').then(res => {
      if (res.data.code === 0){
        res.data.data.carInfo.price /= 1000000
        this.car = res.data.data.carInfo
        this.car.paydate = this.car.paydate.substring(0,10)

        res.data.data.fileList.map(item => {
          var obj = {}
          if(item !== null){
            obj = {
              name: item.name,
              url: item.url
            }
            this.fileList.push(obj)
          }
        });
      }else {
        this.$message.error('信息获取错误，请重试')
        this.$router.replace('/index/buy')
      }
    })

    // 首次加载时,需要调用一次
    this.screenWidth =  window.innerWidth;
    this.setSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () =>{
      this.screenWidth =  window.innerWidth;
      this.setSize();
    }

  }
}
</script>

<style scoped>
.img_show{
  width: 40%;
  float: left;
  margin-top: 5%;
  margin-left: 3%;
}
.info_show{
  width: 50%;
  float: left;
  height: 550px;
  margin-top: 3%;
  padding-left: 3%;
}
.comment_show{
  height: 160px;
  float: left;
  width: 100%;
  overflow-y: scroll;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
.comment_button{
  padding-top: 10px;
  padding-left: 30px;
}
.comment_head{
  font-size: small;
  margin-right: 20px;
}
.el-icon-delete{
  float: right;
  cursor: pointer;
}
.comment_main{
  display: block;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
img{
  /*设置图片宽度和浏览器宽度一致*/
  width:100%;
  height:inherit;
}
.car_fullname_class{
  margin: 0;
  font-size: 26px;
  line-height: 1;
  font-weight: bold;
  color: #111E36;
}
.car_tags{
  display: inline-block;
  margin-top: 14px;
  font-size: small;
  color: blue;
  background-color: rgba(22,206,255,0.51);
  border-radius: 5px;
}
.car_box{
  margin-top: 10px;
  border-radius: 5px;
  height: 55%;
}
.price_show{
  display: inline-block;
  height: 70px;
}
.collect_class{
  display: inline-block;
  padding-left: 120px;
}
.car_buy{
  padding-top: 25px;
  padding-left: 25%;
}
ul,li{
  list-style: none;
  padding: 0;
  margin: 0;
}
li{
  padding-top: 10px;
}
li:hover{
  background-color: #99a9bf;
}
.basic_li{
  padding-top: 28px;
}
.item_name{
  display: inline-block;
  color: #999;
  width: 70px;
}
.price{
  font-size: 36px;
  font-weight: bold;
  display: inline-block;
  color: #F9712C;
  padding-right: 20px;
  position: relative;
  margin-top: 8px;
  float: left;
}

.buttonClass {
  width: 90px;
  height: 60px;
  padding: 0;
  /deep/ i {
    font-size: 20px;
  }
  /deep/  {
    font-size: 20px;
  }
}
</style>